import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
  return (
    <div className="container">
      <Card className="project-card-view">
        {props.vidPath ? (
          <video width="100%" controls>
            <source src={props.vidPath} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <Card.Img variant="top" src={props.imgPath} alt="card-img" />
        )}
        <Card.Body>
          <Card.Title>{props.title}</Card.Title>
          <Card.Text style={{ textAlign: "justify" }}>
            {props.description}
          </Card.Text>

          <Button
            variant="primary"
            href={props.ghLink}
            target="_blank"
            className="me-2">
            <BsGithub /> &nbsp;
            {props.isBlog ? "Blog" : "GitHub"}
          </Button>
          {!props.isBlog && props.demoLink && (
            <Button
              variant="primary"
              href={props.demoLink}
              target="_blank"
              className="ml-10">
              <CgWebsite /> &nbsp;
              {"Demo"}
            </Button>
          )}
        </Card.Body>
      </Card>
    </div>
  );
}

export default ProjectCards;
